export const minecraft12111 = {
  version: '1.21.11',
  title: 'Mounts of Mayhem',
  image: 'https://www.minecraft.net/content/dam/minecraftnet/games/minecraft/key-art/WGD-25_Video-Banner-A_Trailer_1920x1080.jpg',
  releases: [
    {
      id: "230hY3Zxu",
      version: "beta-0.2-1.0.4",
      date: "Jan 6, 2026",
      changelog: "Segunda versión beta para Minecraft 1.21.11 Mounts of Mayhem con más mods agregados y mejoras de rendimiento",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/0.2-1.0.4-1.21.11",
      curseforgeUrl: "https://www.curseforge.com/minecraft/modpacks/simonuwu-fabric-project",
      isBeta: true
    },
    {
      id: "220hY2Zxt",
      version: "beta-0.1-1.0.4",
      date: "Dec 9, 2025",
      changelog: "Primera versión beta para Minecraft 1.21.11 Mounts of Mayhem",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/0.1-1.0.4-1.21.11",
      curseforgeUrl: "https://www.curseforge.com/minecraft/modpacks/simonuwu-fabric-project",
      isBeta: true
    }
  ]
};
